import { checkEmployeeHierarchy } from "@/api/utils"
import { OpenFolderButton } from "@/components/Buttons"
import { SubmittalProps } from "@/interfaces/submittal_types"
import { useAuth } from "@/App"
import { EditSubmittalButton, HandleClose, HandleDelete, HandleEmail } from "@/components/_Shared/Buttons/SubmittalButtons"
import { BaseExpandableRow } from "@/components/_Shared/Table/UI/ExpandableRow/ExpandableRow"

// The expandable row for the submittals table
export function SubmittalRow({ data }: { data: SubmittalProps }) {
    const { user } = useAuth()

    if (!user) {
        return <div>Loading...</div>
    }

    const encoded_submittal_id = encodeURIComponent(data.submittal_id ?? "")
    const roleHierarchy = checkEmployeeHierarchy(user.role)

    return (
        <BaseExpandableRow>
            <div className="flex flex-row gap-2 mx-2">
                <EditSubmittalButton submittal_id={encoded_submittal_id ?? ""} />
                <HandleClose data={data} />
                <HandleEmail data={data} />
                {(roleHierarchy === "MANAGERS" || roleHierarchy === "ADMIN") && <HandleDelete data={data} />}
                <OpenFolderButton folder_path={data.folder_location ?? ""} folder_name="Open Submittal Folder" />
                <OpenFolderButton folder_path={data.parent_project_folder_location ?? ""} folder_name="Open Project Folder" />
            </div>
        </BaseExpandableRow>
    )
}